import { render } from "./rpt_merma_stock.vue?vue&type=template&id=78b3197b"
import script from "./rpt_merma_stock.vue?vue&type=script&lang=js"
export * from "./rpt_merma_stock.vue?vue&type=script&lang=js"

import "./rpt_merma_stock.vue?vue&type=style&index=0&id=78b3197b&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__